import React from 'react';
import { ArrowLeft, Lightning, Envelope, Copy, DownloadSimple, Table, FileText, ShareNetwork, ChatCircle } from '@phosphor-icons/react';

export const CaseHeader = ({ caseData, aiUsage, exporting, exportFile, onShare, onOpenChat, onBack }) => (
  <div className="flex items-start justify-between mb-6">
    <div>
      <button onClick={onBack} className="flex items-center gap-1 text-sm text-[#6B7280] hover:text-[#002FA7] font-ibm mb-2 transition-colors" data-testid="back-to-dashboard">
        <ArrowLeft size={16} /> Back to Cases
      </button>
      <h1 className="font-outfit text-3xl font-bold text-[#09090B]" data-testid="case-title">{caseData.title}</h1>
      <div className="flex items-center gap-3 mt-1 flex-wrap">
        <span className="text-xs font-ibm font-semibold px-2 py-0.5 rounded bg-green-50 text-green-700 border border-green-200">{caseData.status?.toUpperCase()}</span>
        <span className="text-sm text-[#6B7280] font-ibm">{caseData.case_type}</span>
        <span data-testid="case-ai-usage-chip" title={`Input: ${aiUsage.input_tokens || 0} · Output: ${aiUsage.output_tokens || 0} tokens`}
          className="text-xs font-ibm px-2 py-0.5 rounded bg-blue-50 text-blue-700 border border-blue-200 flex items-center gap-1">
          <Lightning size={11} weight="fill" /> AI used: ${Number(aiUsage.cost_usd || 0).toFixed(4)} · {(aiUsage.total_tokens || 0).toLocaleString()} tok
        </span>
        {caseData.inbound_address && (
          <button data-testid="case-inbound-address-chip"
            onClick={() => { navigator.clipboard.writeText(caseData.inbound_address); }}
            title="Copy the forwarding address. Send / forward emails here to add them to this case."
            className="text-xs font-ibm px-2 py-0.5 rounded bg-purple-50 text-purple-700 border border-purple-200 hover:bg-purple-100 transition-all flex items-center gap-1 group">
            <Envelope size={11} /> <span className="font-mono">{caseData.inbound_address}</span> <Copy size={11} className="opacity-60 group-hover:opacity-100" />
          </button>
        )}
      </div>
    </div>
    <div className="flex items-center gap-2">
      <div className="relative group">
        <button data-testid="export-menu-button" className="flex items-center gap-1.5 px-3 py-2 border border-[#E5E7EB] text-[#09090B] font-ibm text-sm rounded-md hover:bg-[#F3F4F6] transition-all">
          <DownloadSimple size={16} /> Export
        </button>
        <div className="absolute right-0 mt-1 w-52 bg-white border border-[#E5E7EB] rounded-lg shadow-lg opacity-0 invisible group-hover:opacity-100 group-hover:visible transition-all z-40">
          <button data-testid="export-timeline-xlsx" onClick={() => exportFile('timeline', 'xlsx')} disabled={!!exporting}
            className="w-full text-left px-4 py-2.5 text-sm font-ibm hover:bg-[#F3F4F6] flex items-center gap-2 transition-colors">
            <Table size={14} /> Timeline (XLSX)
          </button>
          <button data-testid="export-timeline-pdf" onClick={() => exportFile('timeline', 'pdf')} disabled={!!exporting}
            className="w-full text-left px-4 py-2.5 text-sm font-ibm hover:bg-[#F3F4F6] flex items-center gap-2 transition-colors">
            <FileText size={14} /> Timeline (PDF)
          </button>
          <div className="border-t border-[#E5E7EB]" />
          <button data-testid="export-report-pdf" onClick={() => exportFile('report', 'pdf')} disabled={!!exporting}
            className="w-full text-left px-4 py-2.5 text-sm font-ibm hover:bg-[#F3F4F6] flex items-center gap-2 transition-colors">
            <FileText size={14} /> Full Report (PDF)
          </button>
          <button data-testid="export-report-docx" onClick={() => exportFile('report', 'docx')} disabled={!!exporting}
            className="w-full text-left px-4 py-2.5 text-sm font-ibm hover:bg-[#F3F4F6] flex items-center gap-2 transition-colors">
            <FileText size={14} /> Full Report (DOCX)
          </button>
        </div>
      </div>
      <button data-testid="share-case-button" onClick={onShare}
        className="flex items-center gap-1.5 px-3 py-2 border border-[#E5E7EB] text-[#09090B] font-ibm text-sm rounded-md hover:bg-[#F3F4F6] transition-all">
        <ShareNetwork size={16} /> Share
      </button>
      <button data-testid="open-chat-button" onClick={onOpenChat}
        className="flex items-center gap-2 px-4 py-2 bg-[#002FA7] text-white font-ibm font-semibold text-sm rounded-md hover:bg-[#00237D] active:scale-[0.98] transition-all">
        <ChatCircle size={16} weight="fill" /> Ask AI
      </button>
    </div>
  </div>
);
